var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { Flex } from '../Flex';
import { applyVariations } from '../utils';
var TransparentButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n  background-color: transparent;\n  color: inherit;\n\n  &:hover {\n    background-color: transparent;\n    color: inherit;\n  }\n  & > div {\n    display: flex;\n  }\n  &:disabled {\n    background-color: transparent;\n  }\n\n  ", "\n"], ["\n  padding: 0;\n  background-color: transparent;\n  color: inherit;\n\n  &:hover {\n    background-color: transparent;\n    color: inherit;\n  }\n  & > div {\n    display: flex;\n  }\n  &:disabled {\n    background-color: transparent;\n  }\n\n  ", "\n"])), applyVariations('IconButton'));
var propTypes = {
    icon: PropTypes.node,
};
var IconButton = React.forwardRef(function (_a, ref) {
    var icon = _a.icon, props = __rest(_a, ["icon"]);
    return (React.createElement(TransparentButton, __assign({}, props, { ref: ref }),
        React.createElement(Flex, null, icon)));
});
IconButton.displayName = 'IconButton';
IconButton.isIconButton = true;
IconButton.propTypes = propTypes;
export default IconButton;
var templateObject_1;
//# sourceMappingURL=IconButton.js.map